// eslint-disable-next-line max-classes-per-file
import angular from 'angular';
import { AgentModal } from '~/pages/agent/agent.modal';

class AgentNavBar {
	/* @ngInject */
	constructor(Agent, $rootScope, $scope, $injector) {
		this.$injector = $injector;

		// Keep Agent so it's loaded at start
		this.Agent = Agent;
		this.color = 'grey';
		this.spin = false;
		this.text = 'ok';

		$rootScope.$on('agent:connected', () => {
			$scope.$evalAsync(() => {
				// console.log('connected');
				this.color = 'green';
				this.spin = false;
				this.text = 'Connecté';
				this.status = 'connected';
				Agent.status = 'connected';
			});
		});

		$rootScope.$on('agent:denied', () => {
			$scope.$evalAsync(() => {
				// console.log('denied');
				this.color = 'orange';
				this.spin = false;
				this.text = 'Accès refusé';
				this.status = 'denied';
				Agent.status = 'denied';
			});
		});

		$rootScope.$on('agent:error', () => {
			$scope.$evalAsync(() => {
				// console.log('error');
				this.color = 'red';
				this.spin = true;
				this.text = 'Erreur';
				this.status = 'error';
				Agent.status = 'error';
			});
		});

		$rootScope.$on('agent:disconnected', () => {
			$scope.$evalAsync(() => {
				// console.log('disconnected');
				this.color = 'orange';
				this.spin = true;
				this.text = 'Déconnecté';
				this.status = 'disconnected';
				Agent.status = 'disconnected';
			});
		});
	}

	async openModal() {
		const modal = new AgentModal(this.$injector);
		await modal.open();
	}
}

export default angular.module('app').controller('AgentNavBarController', AgentNavBar);
